import { render, staticRenderFns } from "./PressSingle.vue?vue&type=template&id=48228633&scoped=true"
import script from "./PressSingle.vue?vue&type=script&lang=js"
export * from "./PressSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48228633",
  null
  
)

export default component.exports